import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, ChevronDown } from "lucide-react";
import api from "@/lib/api";

export function DeliverTo() {
  const nav = useNavigate();
  const [addr, setAddr] = useState(null);
  useEffect(() => {
    api.get("/marketplace/addresses").then((r) => {
      const list = r.data.addresses || [];
      setAddr(list.find((a) => a.is_default) || list[0] || null);
    }).catch(() => {});
  }, []);
  return (
    <button onClick={() => nav("/app/profile")} data-testid="deliver-to"
      className="hidden shrink-0 items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600 transition hover:border-blue-300 sm:flex">
      <MapPin className="h-4 w-4 text-blue-500" />
      <span className="max-w-[150px] truncate text-left">
        {addr ? <><span className="text-slate-400">Deliver to </span><b className="text-slate-700">{addr.city || addr.district || addr.state}</b>{addr.state && (addr.city || addr.district) ? `, ${addr.state}` : ""}</> : "Set delivery location"}
      </span>
      <ChevronDown className="h-3.5 w-3.5 text-slate-400" />
    </button>
  );
}
